<div class="top_footer supportContainerTop">
    <div class="container supportContainer">
        <div class="row" style="justify-content: center;">
            <div class="row" style="padding: 0% 20%;">
                <div class="col-lg-12">
                    <h6 class="supportHeading"><b>Need Support?</b></h6>
                </div>            
                <div class="col-lg-9 col-md-9">
                    <p class="supportContent">
                        <b>Xpress Service</b><br />
                        {{ServiceCenter?.telephoneNumber}}<br />
                        <a href="mailto:{{ServiceCenter?.emailAddress}}" class="sidemenu_links">{{ServiceCenter?.emailAddress}}</a><br />
                        {{ServiceCenter?.openingHours}} Est
                    </p>
                </div>
                <div class="col-lg-3 col-md-3">
                    <p class="supportContent">
                        <b>Mailing Address:</b> <br>
                        {{needSupport?.underwriterInformation?.addressLine1}}<br /> 
                        {{needSupport?.underwriterInformation?.addressLine2}}<br />
                        {{needSupport?.underwriterInformation?.city}}, {{needSupport?.underwriterInformation?.state}} {{needSupport?.underwriterInformation?.zip}}
                    </p>
                </div>
                <div class="col-lg-9 col-md-9">
                    <p class="supportContent">
                        <b>Billing:</b><br />
                        {{Billing?.telephoneNumber}}<br />
                        <a href="mailto:{{Billing?.emailAddress}}" class="sidemenu_links">{{Billing?.emailAddress}}</a>
                    </p>
                </div>
                <div class="col-lg-3 col-md-3">
                    <p class="supportContent">
                        <b>Claims:</b><br />
                        {{claims?.telephoneNumber}}<br />
                        <a href="mailto:{{claims?.emailAddress}}" class="sidemenu_links">{{claims?.emailAddress}}</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<footer>
    <div class="footwidth">
        <div id="widget-footer" class="row mt-4">
            <div id="custom_html-3" style="padding-left: 0;"  class="widget_text widget col-xs-12 col-md-3 widget_custom_html">
                <div class="textwidget custom-html-widget">
                    <a href="https://berkleymarine.com/" title="Berkley Fire &amp; Marine">
                        <img src="../../../xps/assets/img/BFM_logo_White.png" alt="Berkley Fire &amp; Marine">
                    </a>
                    <p class="mt-4 text-center">
                        <a href="https://www.facebook.com/BerkleyFireMarine">
                            <span class="fa-stack">
                                <i class="fa fa-circle fa-stack-2x text-white" aria-hidden="true"></i>
                                <i class="fa fa-facebook fa-stack-1x fa-inverse text-jwbs" aria-hidden="true"></i>
                            </span>
                        </a>
                        <a href="https://twitter.com/berkleymarine?lang=en">
                            <span class="fa-stack">
                                <i class="fa fa-circle fa-stack-2x text-white" aria-hidden="true"></i>
                                <i class="fa fa-twitter fa-stack-1x fa-inverse text-jwbs" aria-hidden="true"></i>
                            </span>
                        </a>
                        <a href="https://www.linkedin.com/company/berkley-fire-and-marine-a-berkley-company/">
                            <span class="fa-stack">
                                <i class="fa fa-circle fa-stack-2x text-white" aria-hidden="true"></i>
                                <i class="fa fa-linkedin fa-stack-1x fa-inverse text-jwbs" aria-hidden="true"></i>
                            </span>
                        </a>
                        <a href="https://www.youtube.com/channel/UCFcZ8B1u2TSpz6M3BQTbMag">
                            <span class="fa-stack">
                                <i class="fa fa-circle fa-stack-2x text-white" aria-hidden="true"></i>
                                <i class="fa fa-youtube-play fa-stack-1x fa-inverse text-jwbs" aria-hidden="true"></i>
                            </span>
                        </a>
                        <a href="https://www.instagram.com/berkleymarine/">
                            <span class="fa-stack">
                                <i class="fa fa-circle fa-stack-2x text-white" aria-hidden="true"></i>
                                <i class="fa fa-instagram fa-stack-1x fa-inverse text-jwbs" aria-hidden="true"></i>
                            </span>
                        </a>
                    </p>
            </div>
        </div>
            <div id="nav_menu-2" class="widget col-xs-4 col-md-2 widget_nav_menu">
                <h4 class="widgettitle mt-3">Company</h4>
                <div class="menu-footer-company-container">
                    <ul id="menu-footer-company" class="menu">
                        <li id="menu-item-115" class="menu-item menu-item-115"><a href="https://berkleymarine.com/contact/">Contact Us</a></li>
                        <li id="menu-item-116" class="menu-item menu-item-116"><a href="https://berkleymarine.com/about/">About Us</a></li>
                        <li id="menu-item-120" class="menu-item menu-item-120"><a href="https://berkleymarine.com/become-a-partner/">Apply to Partner</a></li>
                        <li id="menu-item-119" class="menu-item menu-item-119"><a href="https://berkleymarine.com/blog/">Resources</a></li>
                    </ul>
    </div>
            </div>
            <div id="nav_menu-3" class="widget col-xs-4 col-md-2 widget_nav_menu">
                <h4 class="widgettitle mt-3">Industries</h4>
                <div class="menu-footer-industries-container">
                    <ul id="menu-footer-industries" class="menu">
                        <li id="menu-item-114" class="menu-item menu-item-114"><a href="https://berkleymarine.com/industry/construction/">Construction Industry</a></li>
                        <li id="menu-item-113" class="menu-item menu-item-113"><a href="https://berkleymarine.com/industry/transportation/">Transportation Industry</a></li>
                        <li id="menu-item-112" class="menu-item menu-item-112"><a href="https://berkleymarine.com/industry/other/">Other Industries</a></li>
                    </ul>
                </div>
            </div>
            <div id="nav_menu-4" class="widget col-xs-4 col-md-2 widget_nav_menu">
                <h4 class="widgettitle mt-3">Resources</h4>
                <div class="menu-footer-resources-container">
                    <ul id="menu-footer-resources" class="menu">
                        <li id="menu-item-110" class="menu-item menu-item-110"><a href="https://careers-berkley.icims.com/jobs/search?ss=1&amp;searchPositionType=24605&amp;mobile=false&amp;width=1068&amp;height=500&amp;bga=true&amp;needsRedirect=false&amp;jan1offset=-420&amp;jun1offset=-360">Careers</a></li>
                        <li id="menu-item-111" class="menu-item menu-item-111"><a href="https://www.berkley.com/">W. R. Berkley Corporation</a></li>
                        <li id="menu-item-109" class="menu-item menu-item-109"><a href="https://www.berkley.com/locator/">Berkley Locator</a></li>
                        <li id="menu-item-115" class="menu-item menu-item-115"><a href="https://ir.berkley.com/news-and-events/news/default.aspx">News</a></li>
                    </ul>
                </div>
            </div>
            <div id="custom_html-2" class="widget_text widget col-xs-12 col-md-3 widget_custom_html">
                <h4 class="widgettitle mt-3">Join the Newsletter</h4>
                <div class="textwidget custom-html-widget"><a href="https://berkleymarine.com/subscribe-to-our-newsletter/" class="btn btn-mailchimp">Subscribe to Our Newsletter</a></div>
            </div>
            <div id="custom_html-4" class="widget_text widget col-xs-12 widget_custom_html">
                <div class="textwidget custom-html-widget">
                    <div class="row d-flex">
                        <div class="col-11 col-sm-10 col-md-9 footcls py-4">
                            <p style="">
                                <a href="https://www.berkley.com/privacy" target="_blank" rel="noopener" style="color: #0093c9;">Privacy Policy &amp; Terms of Use</a> &nbsp;|&nbsp;
                                <a href="http://wrbc.info/Licensing/License.htm" target="_blank" rel="noopener" style="color: #0093c9;">Legal &amp; Licensing</a> &nbsp;|&nbsp;
                                <a href="https://berkleymarine.com/ca-consumer-privacy-act-ccpa" style="color: #0093c9;">CA Consumer Privacy Act (CCPA)</a>
                            </p>
                            <p>© 2021 Berkley Fire &amp; Marine®. All rights reserved. Berkley Fire &amp; Marine is a member of W. R. Berkley Corporation. Products and services are provided by one or more insurance company subsidiaries of W. R. Berkley Corporation. Berkley National Insurance Company • Berkley Regional Insurance Company • StarNet Insurance Company • Berkley Specialty Insurance Company</p>                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>
<div id="parent-company" class="text-center text-white py-1">| <a href="https://www.berkley.com" class="text-white" target="_blank">a Berkley Company</a></div>